export const SECONDARY_MARKET_ORDER_BOOK_ID = '0'



// WEBPACK FOOTER //
// ./src/js/const/offers.const.js